// @ts-strict-ignore
import { getDataFromLocalStorage, setDataToLocalStorage } from 'mobile_web/modules/platform'
import { AccessTypes } from './types'

const key = 'skip_permissions'

export const checkStoredPermissions = async (permissions: AccessTypes[] = []): Promise<boolean> => {
	const data = (await getDataFromLocalStorage(key)) || []

	if (data.length === 0) {
		return false
	}

	const isExist = data.every(item => permissions.includes(item))

	return isExist
}

export const skipPermissionsModal = async (permissions: AccessTypes[] = []): Promise<void> => {
	const data = (await getDataFromLocalStorage(key)) || []
	const isExist = await checkStoredPermissions(permissions)

	if (isExist) {
		return
	}

	setDataToLocalStorage(key, [...data, ...permissions])
}
